import styled from '@emotion/styled';

export const WidgetCard = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 24px;
  box-shadow:
    0px 12px 42px -4px rgba(0, 0, 0, 0.12),
    0px 8px 18px -6px rgba(0, 0, 0, 0.12);
  overflow: hidden;
`;

export const WidgetHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 24px;
  border-bottom: 1px solid #dcdcdc;
`;

export const WidgetTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1e1e1e;
`;

export const WidgetHeaderIcon = styled.span`
  display: flex;
  align-items: center;
  color: #0073ff;
  font-size: 24px;

  svg {
    font-size: 24px;
  }
`;

/* ── Active state ── */

export const ExperimentRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #dcdcdc;
  align-items: center;
`;

export const ExperimentNameBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px;
`;

export const ExperimentLink = styled.a`
  font-size: 14px;
  font-weight: 700;
  color: #0073ff;
  text-decoration: none;
  cursor: pointer;
  line-height: 1.3;

  &:hover {
    text-decoration: underline;
  }
`;

export const ExperimentMetricLabel = styled.span`
  font-size: 12px;
  color: #6e6e71;
  font-weight: 400;
`;

export const ExperimentMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  flex-shrink: 0;

  svg {
    font-size: 16px;
    color: #6e6e71;
  }
`;

export const DayBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.1;
`;

export const DayLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #1e1e1e;
`;

export const StatusText = styled.span`
  font-size: 11px;
  font-weight: 400;
  color: #6e6e71;
`;

export const VariantTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  th {
    text-align: left;
    font-weight: 500;
    color: #6e6e71;
    font-size: 14px;
    padding: 10px 24px 6px;
  }

  th:nth-child(2),
  th:nth-child(3) {
    text-align: right;
  }

  td {
    padding: 8px 24px;
    border-bottom: 1px solid #dcdcdc;
    color: #1e1e1e;
  }

  td.var {
    font-style: italic;
    font-weight: 500;
    color: #1e1e1e;
  }

  td.num {
    text-align: right;
    color: #1e1e1e;
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

export const WidgetFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #dcdcdc;
`;

export const FooterLink = styled.a`
  font-size: 14px;
  color: #0073ff;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  svg {
    font-size: 16px;
  }
`;

/* ── Empty state ── */

export const EmptyStateIntro = styled.div`
  padding: 16px 24px 8px;
  font-size: 14px;
  color: #6e6e71;
  line-height: 1.4;
`;

/* ── Shared ── */

export const LoadingState = styled.div`
  font-size: 13px;
  color: #afafaf;
  text-align: center;
  padding: 32px 0;
`;

export const ErrorState = styled.div`
  font-size: 13px;
  color: #afafaf;
  text-align: center;
  padding: 32px 0;
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
